import { I18nProvider } from './i18n/I18nProvider';
import type { Language } from './i18n/catalogs';
import { AuthProvider } from './auth/AuthProvider';
import type { AuthClient } from './auth/authClient';
import type { AuthSession } from './auth/types';
import { RouterProvider } from './app/router';
import { Root } from './app/Root';

export interface AppProps {
  initialLanguage?: Language;
  initialSession?: AuthSession | null;
  initialPath?: string;
  authClient?: AuthClient;
}

export function App({ initialLanguage, initialSession, initialPath, authClient }: AppProps): JSX.Element {
  return (
    <I18nProvider initialLanguage={initialLanguage}>
      <AuthProvider initialSession={initialSession} client={authClient}>
        <RouterProvider initialPath={initialPath}>
          <Root />
        </RouterProvider>
      </AuthProvider>
    </I18nProvider>
  );
}
